import {
    UPDATE_SESSION, SystemState, SystemActionTypes, TOGGLE_LOADING_INDICATOR,
    SHOW_HEADER, SET_MESSAGE_RESPONSE, SHOW_MENUBAR, MessageResponse, SET_TITLE, RESET_TITLE,
    SHOW_FOOTER
} from "./types";
let title: string = "";
switch(process.env.REACT_APP_CODE_TENANT){
    case "OG":
        title = "OG - Insurance & Solution";
        break;
    case "VA":
        title = "Vale";
    break;
    case "SA":
        title = "Salud";
    break;
    case "OP":
        title = "Progressa";
    break;
    }

export const initialState: SystemState = {
    loggedIn: false,
    session: "",
    username: "",
    showLoading: false,
    messageResponse: null,
    showHeader: false,
    showMenubar: false,
    title,
    showFooter: false,
};

export function systemReducer(
    state = initialState,
    action: SystemActionTypes
): SystemState {
    switch (action.type) {
        case UPDATE_SESSION:
            return {
                ...state,
                ...action.payload as SystemState
            };
        case TOGGLE_LOADING_INDICATOR:
            return {
                ...state,
                showLoading: action.payload as boolean
            };
        case SET_MESSAGE_RESPONSE:
            return {
                ...state,
                messageResponse: action.payload as MessageResponse
            };
        case SHOW_HEADER:
            return {
                ...state,
                showHeader: action.payload as boolean
            };
        case SHOW_MENUBAR:
            return {
                ...state,
                showMenubar: action.payload as boolean
            };
        case SET_TITLE:
            return {
                ...state,
                title : action.payload as string
            };
        case RESET_TITLE:
            return {
                ...state,
                title : initialState.title
            };
        case SHOW_FOOTER:
                return {
                    ...state,
                    showFooter : action.payload as boolean
                };
        default:
            return state;
    }
}
